import apiPath from "@/plugins/api";
import axios from "axios";
export const state = () => ({
  state: {
    listSetting: {},
    stateLogout: {},
  },
});

export const mutations = {
  setListSetting: async function (state, val) {
    state.listSetting = val;
  },

  setLogout: async function (state, val) {
    state.stateLogout = val;
  },
  setLogoutAzure: async function (state, val) {
    state.stateLogoutAzure = val;
  },
};

export const actions = {
  setListSetting: async ({ commit }, payload) => {
    await axios.post(`${apiPath}/setting/getlist`).then(
      async (data) => {
        commit("setListSetting", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
        }
      }
    );
  },

  getLogout: async ({ commit }) => {
    await axios.post(`${apiPath}/Login/logout`).then(
      async (data) => {
        commit("setLogout", data.data);
      },
      (error) => {
        const code = parseInt(error.response && error.response.status);
        if (code === 401) {
        }
      }
    );
  },
};

export default {
  state,
  actions,
  mutations,
};
